export const PENDING = 'PENDING';
export const BANK_PAYOUT_PENDING = 'pending';
export const BANK_PAYOUT_APPROVED = 'approved';
export const BANK_PAYOUT_DECLINED = 'declined';
